const catalogue = require("./catalogue");

module.exports = catalogue;



//////////////////
// WEBPACK FOOTER
// ./~/javascriptstuff-db/index.js
// module id = 775
// module chunks = 84419135593297